import React from 'react';
import ContractList from './ContractList';
import { contractsColumns } from '../enums/columns';

const columns = [
  contractsColumns.contract,
  contractsColumns.commodity,
  contractsColumns.contractPeriod,
  contractsColumns.product,
  contractsColumns.productType,
  contractsColumns.purchaseMethod,
  contractsColumns.contractNumber,
  contractsColumns.organisation,
  contractsColumns.companyID,
  contractsColumns.kam,
  contractsColumns.purchasedPercent,
  contractsColumns.purchased,
  contractsColumns.volume,
  contractsColumns.remains,
  contractsColumns.remains1,
  contractsColumns.remains2,
  contractsColumns.remains3,
  contractsColumns.remains4,
  contractsColumns.remains5,
  contractsColumns.remains6,
  contractsColumns.remains7,
  contractsColumns.remains8,
  contractsColumns.remains9,
  contractsColumns.remains10,
  contractsColumns.remains11,
  contractsColumns.remains12,
];

const ContractListCustomer = () => {
  return <ContractList columns={columns} showToolbarIcons={false} />;
};

ContractListCustomer.propTypes = {};

export default ContractListCustomer;
